const awsExports = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      loginWith: {
        email: process.env.REACT_APP_LOGIN_EMAIL === 'true',
        phone: process.env.REACT_APP_LOGIN_PHONE === 'true',
        username: process.env.REACT_APP_LOGIN_USERNAME === 'true'
      }
    }
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_S3_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    }
  }
};

export default awsExports;
